
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { History, Loader2 } from 'lucide-react';
import { useCallHistoryData } from '@/hooks/useCallHistoryData';
import { CallHistoryFilters } from './CallHistoryFilters';
import { CallHistoryItem } from './CallHistoryItem';

export const CallHistory = () => {
  const {
    callHistory,
    loading,
    error,
    searchQuery,
    setSearchQuery,
    filterOutcome,
    setFilterOutcome,
    exportHistory,
    totalCount
  } = useCallHistoryData();

  if (error) {
    return (
      <div className="h-full flex items-center justify-center p-8">
        <Card className="p-6 text-center">
          <History className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
          <h3 className="text-lg font-semibold mb-2">Error Loading Call History</h3>
          <p className="text-sm text-muted-foreground">
            {error}
          </p>
        </Card>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col">
      {/* Header and Filters */}
      <Card className="border-0 border-b rounded-none">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm flex items-center gap-2">
            <History className="h-4 w-4" />
            Call History ({callHistory.length})
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CallHistoryFilters
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
            filterOutcome={filterOutcome}
            onFilterChange={setFilterOutcome}
            onExport={exportHistory}
          />
        </CardContent>
      </Card>

      {/* History List */}
      <ScrollArea className="flex-1">
        <div className="p-4 space-y-3">
          {loading && callHistory.length === 0 ? (
            <div className="text-center py-8">
              <Loader2 className="h-8 w-8 mx-auto mb-4 text-muted-foreground animate-spin" />
              <p className="text-muted-foreground text-sm">Loading call history...</p>
            </div>
          ) : callHistory.length === 0 ? (
            <div className="text-center py-8">
              <History className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
              <p className="text-muted-foreground text-sm">
                {searchQuery || filterOutcome !== 'all' 
                  ? 'No calls match your search criteria'
                  : 'No call history available'
                }
              </p>
            </div>
          ) : (
            callHistory.map((call) => (
              <CallHistoryItem key={call.id} call={call} />
            ))
          )}
        </div>
      </ScrollArea>
    </div>
  );
};
